// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_59-2";
export var blackBorderOnHover = "_59-7";
export var cell = "_59-6";
export var cellContainer = "_59-3";
export var checked = "_59-8";
export var disabled = "_59-5";
export var featuredIconCellContainer = "_59-9";
export var featuredIconTextContainer = "_59-b";
export var featuredIconWrapper = "_59-a";
export var noBorder = "_59-c";
export var orangeSelectedRow = "_dg-3";
export var overflowableText = "_59-0";
export var overflowableTextContainer = "_59-1";
export var row = "_57-0";
export var rowCheckboxCell = "_59-4";
export var selectableTable = "_dg-2";